import { getTokensOrLogin } from "@genai/auth";
import config from "@genai/config";
import { toApiUrl } from "./toApiUrl";

const httpClient = async (
  ...args: Parameters<typeof fetch>
): ReturnType<typeof fetch> => {
  const url = toApiUrl(args[0]);
    if (!config.enableOktaAuth) {
      const headers = { Authorization: "Bearer superadmin@genai.digital.engie.com", };
      const options = {
        ...args[1], // This includes method, body, and other fields
        headers: {
          ...(args[1]?.headers || {}),
          ...headers, // Add or overwrite Authorization header
        },
      };
      return fetch(url, options);
  }

  const { accessToken, idToken } = (await getTokensOrLogin()) || {};
  if (!accessToken || !idToken) {
    throw new Error("Not authenticated");
  }
  const headers = {
    ...(args[1]?.headers || {}),
    Authorization: idToken,
  };

  const options = {
    ...args[1],
    headers,
  };

  return fetch(url, options);
};

export { httpClient };
